import { AuthConfig } from 'angular-oauth2-oidc';
import { LogLevels, InstanceTypes } from 'ng-shared-library';

export const errorInterceptorSkipHeader = 'X-Skip-Error-Interceptor';
export const loadingInterceptorSkipHeader = 'X-Skip-Loading-Interceptor';
export const loginRedirectSkipHeader = 'X-Skip-Login-Redirect';

export const environment = {
  production: false,
  apiUrlRoot: '/api_dev',
  authUrl: 'https://portal.agilepayroll.com/devauthapi',
  defaultTaskDueTime: '15:00', // hh:mm
  watermarkText: 'LANDING DEV',
  logLevel: LogLevels.Debug,
  // 6208: per Paula and Richard, use 50 min so we check for idle before the 60min timeout
  // prior to the auth cookie itself hitting its expiration limit  --nk 2020-07-28
  idleLimitSeconds: 600,
  idleReloginGraceSeconds: 180,
  GoogleTrackingId: 'G-96TPX9XC98',
  instanceType: InstanceTypes.LandingPortal,
  defaultOfficeGroup: 'DEFAULT_OFFICE_GROUP',
  siteUrlRoot: 'https://olympus.connectpayusa.com/login_dev',
  landingPortalUrl: 'https://olympus.connectpayusa.com/login_dev',
  opsPortalUrl: 'https://olympus.connectpayusa.com/apollo_dev',
  endOfDayCutoff: {
    hours: 17,
    minutes: 0
  },
  allowedRoles: ['Client Portal User', 'Client Portal Admin', 'Employee Portal User'],
  permissionRoles: ['Client Portal User', 'Client Portal Admin', 'Employee Portal User'],
  enableTestNotifications: true
};

// dev id server
export const authCodeFlowConfig: AuthConfig = {
  issuer: 'https://dev-accounts.connectpayusa.com',
  clientId: '04af8141-2485-4790-82de-a52f5554e189_relay.portal',
  redirectUri: 'https://olympus.connectpayusa.com/login_dev/authenticate',
  postLogoutRedirectUri: 'https://olympus.connectpayusa.com/login_dev',
  logoutUrl: 'https://dev-accounts.connectpayusa.com/connect/endsession',
  responseType: 'code',
  scope:
    'openid roles userprofile cp.relay.api.client cp.relay.api.employee cp.identity.api.general',
  showDebugInformation: true,
  disablePKCE: true,
  customQueryParams: { prompt: 'login' }
};
